import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const AddFlowSubmitter = createAsyncThunk(
  "AddFlowSubmitter",
  async (aI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/Flow/AddFlowSubmitter", {
        aI_ApplicationInformationId: aI_ApplicationInformationId,
      });

      const data = response.data.success;
      //console.log(data, "dataflow");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const FlowSubmitter = createSlice({
  name: "FlowSubmitter",
  initialState: {
    FlowSubmitter: {},
    loadingFlowSubmitter: false,
    errorFlowSubmitter: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(AddFlowSubmitter.pending, (state, action) => {
        state.loadingFlowSubmitter = true;
        state.FlowSubmitter = action.payload;
        state.errorFlowSubmitter = null;
      })
      .addCase(AddFlowSubmitter.fulfilled, (state, action) => {
        state.loadingFlowSubmitter = false;
        state.FlowSubmitter = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddFlowSubmitter.rejected, (state, action) => {
        state.loadingFlowSubmitter = false;
        state.errorFlowSubmitter = action.payload;
      });
  },
});
export default FlowSubmitter.reducer;
